<template>
  <el-container>
    <el-dialog :title="selRow.id == undefined ? '新增产品信息' : '编辑产品信息'" :visible="visible" @opened="handleOpen" :before-close="handleClose" append-to-body
               :wrapperClosable="false" :close-on-click-modal="false">
      <el-row style="padding: 30px">
        <el-form ref="form" :model="form" :rules="rules" label-width="90px" inline>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="productName" width="100%">
              <el-input v-model="form.productName" placeholder="请输入产品名称" size="medium" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="价格" prop="nowPrice" width="100%">
              <el-input v-model="form.nowPrice" placeholder="请输入产品当前价格" size="medium" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品类" prop="categoryId">
              <el-select @change="categoryChange" v-model="form.categoryId" placeholder="请选择品类" style="width: 100%" size="medium">
                <el-option v-for="item in category" :key="item.id" :label="item.name"
                           :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="具体品类" prop="category2Id">
              <el-select v-model="form.category2Id" placeholder="请选择具体品类" style="width: 100%" size="medium">
                <el-option v-for="item in category2" :key="item.id" :label="item.name"
                           :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产地" prop="productAddr" width="100%">
              <el-input v-model="form.productAddr" placeholder="请输入产品产地" size="medium" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重量" prop="productWeight" width="100%">
              <el-input v-model="form.productWeight" placeholder="请输入产品重量" size="medium" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="材质" prop="productMaterial" width="100%">
              <el-input v-model="form.productMaterial" placeholder="请输入产品材质" size="medium" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序号" prop="orderNo" width="100%">
              <el-input v-model="form.orderNo" placeholder="请输入排序号" size="medium" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否显示" prop="isShow" width="100%">
              <el-tooltip :content="'Switch value: ' + form.isShow" placement="top">
                <el-switch
                    v-model="form.isShow"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0">
                </el-switch>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="信息简介" prop="productDetail" width="100%">
              <quill-editor :id="randomString(3)"
                  v-model="form.productDetail"
                  ref="productQuillEditor"
                  :options="productEditorOption"
                  @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                  @change="onEditorChange($event)">
              </quill-editor>
              <el-upload action="#" :accept="attachAcceptType" :key="randomString(3)"
                         class="avatar-uploader"
                         :http-request="onProductUploadHandler"
                         :show-file-list="false" >
              </el-upload>
            </el-form-item>
            <el-form-item label="列表图片" prop="attachList">
              <el-upload action="/sysAttach/uploadTempAttach/PRODUCT"
                         list-type="text" :accept="attachAcceptType"
                         :on-error="attachHandleError" :on-success="attachHandleSuccess"
                         :on-remove="attachHandleRemove" :on-preview="attachHandlePreview"
                         :before-upload="attachBeforeUpload" :before-remove="attachBeforeRemove"
                         :on-exceed="attachHandleExceedOne" :file-list="attachList" :limit="1"
                         :show-file-list=true multiple style="width: 500px">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red"> 上传文件大小不超过10MB，最多上传1个图片</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <el-row class="drawer_footer">
        <el-button type="primary" @click="submit" size="medium" :disabled="$store.state.loading">确 定</el-button>
        <el-button @click="handleClose" size="medium" :disabled="$store.state.loading">取 消</el-button>
      </el-row>
    </el-dialog>
  </el-container>
</template>

<script>
import {addProduct, updateProduct, getInfoProductFindTree} from "@/api/core/infoProduct";
import {commonAttachMixin} from "../../../../utils/commonAttachMixin";

export default {
  name: "ProductForm",
  mixins: [commonAttachMixin],
  props: ['selRow','formState', 'category'],
  data() {
    return {
      parentOptions: [],
      category2: [],
      attachAcceptType: '.jpg,.jpeg,.png,.gif,.bmp,.tiff,.svg,.PNG,.JPG,.JPEG',
      content: `<p></p><p><br></p><ol><li><strong><em>Or drag/paste an image here.</em></strong></li><li><strong><em>rerew</em></strong></li><li><strong><em>rtrete</em></strong></li><li><strong><em>tytrytr</em></strong></li><li><strong><em>uytu</em></strong></li></ol>`,
      productEditorOption: {
        placeholder: "请在这里输入",
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],    //加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'],     //引用，代码块
              [{'header': 1}, {'header': 2}],        // 标题，键值对的形式；1、2表示字体大小
              [{'list': 'ordered'}, {'list': 'bullet'}],     //列表
              [{'script': 'sub'}, {'script': 'super'}],   // 上下标
              [{'indent': '-1'}, {'indent': '+1'}],     // 缩进
              [{'direction': 'rtl'}],             // 文本方向
              [{'size': ['small', false, 'large', 'huge']}], // 字体大小
              [{'header': [1, 2, 3, 4, 5, 6, false]}],     //几级标题
              [{'color': []}, {'background': []}],     // 字体颜色，字体背景颜色
              [{'font': []}],     //字体
              [{'align': []}],    //对齐方式
              ['clean'],    //清除字体样式
              ['image']    //上传图片
            ],
            handlers: {
              'image': function (value) {
                if (value) { // value === true
                  let dom = document.querySelectorAll('.avatar-uploader input')
                  console.log(dom)
                  dom[dom.length-1].click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      form: {},
      rules: {
        productName: [
          {required: true, message: '请输入产品名称', trigger: 'blur'}
        ],
        nowPrice: [
          {required: true, message: '请输入价格', trigger: 'blur'},
          { validator: (rule, value, callback) => {
              if (/^\d+(\.\d{1,2})?$/.test(value)) {
                callback();
              } else {
                callback(new Error('请输入正确的价格'));
              }
            }, trigger: 'blur'
          }
        ],
        categoryId: [
          {required: true, message: '请选择品类', trigger: 'change'}
        ],
        category2Id: [
          {required: true, message: '请选择具体品类', trigger: 'change'}
        ],
      },
      visible:false
    }
  },
  computed: {
    editor() {
      return this.$refs.productQuillEditor.quill;
    },
  },

  methods:{
    async categoryChange(e){
      let {obj} = await this.postRequest('/core/infoProductCategory2/findListByPid',{pid: e});
      this.category2 = obj
    },
    //获取Tree
    findInfoProductFindTree() {
      getInfoProductFindTree().then(res => {
        console.log();
        if (res.status == 200) {
          console.log("树:" + JSON.stringify(res.obj))
          this.parentOptions = res.obj;
        }
      })
    },
    async handleOpen() {
      this.attachList = []
      if(this.selRow.id && this.selRow.categoryId){
        let {obj} = await this.postRequest('/core/infoProductCategory2/findListByPid',{pid: this.selRow.categoryId});
        this.category2 = obj
      }
      this.form = {...this.selRow};
      this.onEditorReady(this.editor)
      if (this.form.id) {
        this.attachList = await this.findAttachListByDataId(this.form.id, 'PRODUCT')
      }
      this.findInfoProductFindTree();
    },
    onEditorReady(editor) { // 准备编辑器
    },
    onEditorBlur() {
    }, // 失去焦点事件
    onEditorFocus() {
    }, // 获得焦点事件
    onEditorChange() {
    }, // 内容改变事件
    //下边是弹出
    handleClose() {
      this.$refs.form.clearValidate();
      this.visible = false;
    },

    // 确定
   async submit() {
      let that = this
      let is_add = that.form.id ? true: false
     let param = that.form;
     let pid = param.pid;
     if( Array.isArray(pid)){
       param.pid = pid[pid.length - 1];
     }
      that.$refs.form.validate().then(()=>{
        if (is_add){
          return updateProduct(that.form)
        }
        return addProduct(that.form)
      }).then(res => {
        that.handleClose()
        if (res.status == 200) {
          if (is_add){
            that.$message({
              type: "success",
              message: '编辑成功'
            });
          }else {
            that.$message({
              type: "success",
              message: '添加成功'
            });
          }
          that.$emit('refreshList')
        }
      }).catch(() => {
      })
    },
    attachHandleExceedOne(files, fileList) {
      this.$message.warning(`只能上传1个图片`)
    },
    attachBeforeRemove(file) {
      if (file.status !== 'success') return;
      return this.$confirm(`确定删除图片 ${file.name}重新上传？`, '提示', {type: 'warning'}).then(_ => {
        if (file.id && file.state && file.state === 1) {
          this.postRequest('/sysAttach/delete', {'attachId': file.id});
        }

      });
    },
    async onProductUploadHandler(e) {
      let formData = new FormData()
      formData.append('file', e.file)
      this.postRequestFile("/sysAttach/uploadEditorFile/PRODUCT",formData).then(res => {
        if (res.status === 200) {
          console.log("图片url++++",res)
          // 获取光标所在位置
          let quill = this.$refs.productQuillEditor.quill
          let length = quill.getSelection().index
          //let length = quill.selection.savedRange.index
          // 插入图片
          quill.insertEmbed(length, 'image', res.msg)
          // 调整光标到最后
          quill.setSelection(length + 1)
        }
      })
    },
    randomString(len){
      //默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var tempLen = chars.length, tempStr='';
      for(var i=0; i<len; ++i){
        tempStr += chars.charAt(Math.floor(Math.random() * tempLen ));
      }
      return tempStr;
    }
  }
}
</script>

<style scoped>

</style>